import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ConfigurationComponent} from './configuration.component';
import {ConfigComponent} from './config/config.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {MstLandmarkModule} from './mst-landmark/mst-landmark.module';
import {MpathTestTemplateModule} from './mpath-test-template/mpath-test-template.module';
import {MemrAutoDailyCloseVisitModule} from './memr-auto-daily-close-visit/memr-auto-daily-close-visit.module';
import {MstDischargeSummaryFormModule} from './mst-discharge-summary-form/mst-discharge-summary-form.module';
import {InvServiceWiseItemConsumptionModule} from './inv-service-wise-item-consumption/inv-service-wise-item-consumption.module';
import {TemrVisitDoctorsNoteModule} from './temr-visit-doctors-note/temr-visit-doctors-note.module';
import {InvItemSubTypeModule} from './inv-item-subtype/inv-item-subtype.module';


const routes: Routes = [
    {path: 'login', loadChildren: 'app/login/login.module#LoginModule'},
    {
        path: 'configuration', component: ConfigurationComponent,
        children: [
            {
                path: 'config/:name', component: ConfigComponent
            },
            {path: 'change_password', loadChildren: './change-password/change-password.module#ChangePasswordModule'},
            {path: 'medical-emergency', loadChildren: './Medical-emergency-code/Medical-emergency-code.module#MedicalEmergencyCodeModule'},
            {path: 'mac-account-head', loadChildren: './mac-account-head/mac-account-head.module#MacAccountHeadModule'},
            {path: 'configShortcut', loadChildren: './configShortcut/configShortcut.module#ConfigShortCutModule'},
            {
                path: 'mac-accounting-group',
                loadChildren: './mac-accounting-group/mac-accounting-group.module#MacAccountingGroupModule'
            },
            {path: 'homesortcut', loadChildren: './homesortcut/homesortcut.module#HomesortcutModule'},
            {path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule'},
            {path: 'mac-cost-category', loadChildren: './mac-cost-category/mac-cost-category.module#MacCostCategoryModule'},
            {path: 'mac-cost-centre', loadChildren: './mac-cost-centre/mac-cost-centre.module#MacCostCentreModule'},
            {path: 'mac-currency', loadChildren: './mac-currency/mac-currency.module#MacCurrencyModule'},
            {path: 'mac-ledger', loadChildren: './mac-ledger/mac-ledger.module#MacLedgerModule'},
            {path: 'mac-parent', loadChildren: './mac-parent/mac-parent.module#MacParentModule'},
            {path: 'mac-tax', loadChildren: './mac-tax/mac-tax.module#MacTaxModule'},
            {path: 'mac-tax-type', loadChildren: './mac-tax-type/mac-tax-type.module#MacTaxTypeModule'},
            {
                path: 'mac-transction-type',
                loadChildren: './mac-transction-type/mac-transction-type.module#MacTransctionTypeModule'
            },
            {path: 'mac-voucher-type', loadChildren: './mac-voucher-type/mac-voucher-type.module#MacVoucherTypeModule'},
            {
                path: 'mbill-advance-against',
                loadChildren: './mbill-advance-against/mbill-advance-against.module#MbillAdvanceAgainstModule'
            },
            {
                path: 'mbill-concessiontemplate',
                loadChildren: './mbill-concession-template/mbill-concession-template.module#MbillConcessionTemplateModule'
            },
            {
                path: 'mbill-concessioncategory',
                loadChildren: './mbill-concession-category/mbill-concession-category.module#MbillConcessionCategoryModule'
            },
            {path: 'mbill-group', loadChildren: './mbill-group/mbill-group.module#MbillGroupModule'},
            {path: 'mbill-item', loadChildren: './mbill-item/mbill-item.module#MbillItemModule'},
            {
                path: 'mbill-item-category',
                loadChildren: './mbill-item-category/mbill-item-category.module#MbillItemCategoryModule'
            },
            {path: 'mbill-plan', loadChildren: './mbill-plan/mbill-plan.module#MbillPlanModule'},
            {path: 'mbill-service', loadChildren: './mbill-service/mbill-service.module#MbillServiceModule'},
            {path: 'mst-visit-service', loadChildren: './mst-visit-service/mst-visit-service.module#MstVisitService'},
            {path: 'mbill-package', loadChildren: './mbill-package/mbill-package.module#MbillPackageModule'},
            {path: 'mbill-tariff', loadChildren: './mbill-tariff/mbill-tariff.module#MbillTariffModule'},
            {
                path: 'mbill-service-codetype',
                loadChildren: './mbill-service-codetype/mbill-service-codetype.module#MbillServiceCodetypeModule'
            },
            {path: 'mbill-sub-group', loadChildren: './mbill-sub-group/mbill-sub-group.module#MbillSubGroupModule'},
            {path: 'mbill-service', loadChildren: './mbill-service/mbill-service.module#MbillServiceModule'},
            {
                path: 'mbill-terms-payment',
                loadChildren: './mbill-terms-payment/mbill-terms-payment.module#MbillTermsPaymentModule'
            },
            {path: 'memr-allergy', loadChildren: './memr-allergy/memr-allergy.module#MemrAllergyModule'},
            {
                path: 'clinical-procedure',
                loadChildren: './memr-clinical-procedure/memr-clinical-procedure.module#MemrClinicalProcedureModule'
            },
            {
                path: 'memr-dose-frequency',
                loadChildren: './memr-dose-frequency/memr-dose-frequency.module#MemrDoseFrequencyModule'
            },
            {
                path: 'memr-drug-instruction',
                loadChildren: './memr-drug-instruction/memr-drug-instruction.module#MemrDrugInstructionModule'
            },
            {
                path: 'mst-discharge-special-instruction',
                loadChildren: './mst-discharge-special-instruction/mst-discharge-special-instruction.module#MstDischargeSpecialInstructionModule'
            },
            {
                path: 'mst-discharge-spinstruction-group',
                loadChildren: './mst-discharge-spinstruction-group/mst-discharge-spinstruction-group.module#MstDischargeSpinstructionGroupModule'
            },
            {
                path: 'referral-template',
                loadChildren: './memr-referral-template/memr-referral-template.module#MemrReferralTemplateModule'
            },
            {path: 'minv-dispensing', loadChildren: './minv-dispensing/minv-dispensing.module#MinvDispensingModule'},
            {
                path: 'mgrn-item-checklist',
                loadChildren: './minv-grn-item-checklist/minv-grn-item-checklist.module#MinvGrnItemChecklistModule'
            },
            // {path: 'mitem-company', loadChildren: './minv-item-company/minv-item-company.module#MinvItemCompanyModule'},
            // {
            //     path: 'mmode-scrapsale',
            //     loadChildren: './minv-mode-scrapsale/minv-mode-scrapsale.module#MinvModeScrapsaleModule'   Commented by Neha
            // },
            {path: 'mmolecule', loadChildren: './minv-molecule/minv-molecule.module#MinvMoleculeModule'},
            // {
            //     path: 'mpregnency-type',
            //     loadChildren: './minv-pregnency-type/minv-pregnency-type.module#MinvPregnencyTypeModule'
            // },
            // {path: 'mstorage-type', loadChildren: './minv-storage-type/minv-storage-type.module#MinvStorageTypeModule'},
            // {path: 'mstore', loadChildren: './minv-store/minv-store.module#MinvStoreModule'},
            // {path: 'msupplier', loadChildren: './minv-supplier/minv-supplier.module#MinvSupplierModule'},
            // {
            //     path: 'mtherapeutic-class',
            //     loadChildren: './minv-therapeutic-class/minv-therapeutic-class.module#MinvTherapeuticClassModule' Commented by Neha
            // },
            {
                path: 'mipd-admission-type',
                loadChildren: './mipd-admission-type/mipd-admission-type.module#MipdAdmissionTypeModule'
            },
            {path: 'mipd-auto-charge', loadChildren: './mipd-auto-charge/mipd-auto-charge.module#MipdAutoChargeModule'},
            {path: 'mipd-bed', loadChildren: './mipd-bed/mipd-bed.module#MipdBedModule'},
            {path: 'mipd-bed-amenity', loadChildren: './mipd-bed-amenity/mipd-bed-amenity.module#MipdBedAmenityModule'},
            {path: 'mipd-bed-class', loadChildren: './mipd-bed-class/mipd-bed-class.module#MipdBedClassModule'},
            {
                path: 'mipd-bed-release-checklist',
                loadChildren: './mipd-bed-release-checklist/mipd-bed-release-checklist.module#MipdBedReleaseChecklistModule'
            },
            {path: 'mipd-block', loadChildren: './mipd-block/mipd-block.module#MipdBlockModule'},
            {
                path: 'mipd-discharge-destination',
                loadChildren: './mipd-discharge-destination/mipd-discharge-destination.module#MipdDischargeDestinationModule'
            },
            {
                path: 'mipd-discharge-template',
                loadChildren: './mipd-discharge-template/mipd-discharge-template.module#MipdDischargeTemplateModule'
            },
            {
                path: 'mipd-discharge-type',
                loadChildren: './mipd-discharge-type/mipd-discharge-type.module#MipdDischargeTypeModule'
            },
            {path: 'mipd-floor', loadChildren: './mipd-floor/mipd-floor.module#MipdFloorModule'},
            {path: 'mipd-room', loadChildren: './mipd-room/mipd-room.module#MipdRoomModule'},
            {path: 'mipd-room-amenity', loadChildren: './mipd-room-amenity/mipd-room-amenity.module#MipdRoomAmenityModule'},
            {path: 'mipd-vital', loadChildren: './mipd-vital/mipd-vital.module#MipdVitalModule'},
            {path: 'mipd-ward', loadChildren: './mipd-ward/mipd-ward.module#MipdWardModule'},
            {
                path: 'mot-anesthesia-note',
                loadChildren: './mot-anesthesia-note/mot-anesthesia-note.module#MotAnesthesiaNoteModule'
            },
            {
                path: 'mot-anesthesia-type',
                loadChildren: './mot-anesthesia-type/mot-anesthesia-type.module#MotAnesthesiaTypeModule'
            },
            {
                path: 'mot-intra-operative-instruction',
                loadChildren: './mot-intra-operative-instruction/mot-intra-operative-instruction.module#MotIntraOperativeInstructionModule'
            },
            {
                path: 'mot-operation-result',
                loadChildren: './mot-operation-result/mot-operation-result.module#MotOperationResultModule'
            },
            {
                path: 'mot-operation-theater',
                loadChildren: './mot-operation-theater/mot-operation-theater.module#MotOperationTheaterModule'
            },
            {
                path: 'mot-post-operative-instruction',
                loadChildren: './mot-post-operative-instruction/mot-post-operative-instruction.module#MotPostOperativeInstructionModule'
            },
            {
                path: 'mot-pre-operative-instruction',
                loadChildren: './mot-pre-operative-instruction/mot-pre-operative-instruction.module#MotPreOperativeInstructionModule'
            },
            {
                path: 'mot-procedure-category',
                loadChildren: './mot-procedure-category/mot-procedure-category.module#MotProcedureCategoryModule'
            },
            {
                path: 'mot-procedure-checklist',
                loadChildren: './mot-procedure-checklist/mot-procedure-checklist.module#MotProcedureChecklistModule'
            },
            {
                path: 'mot-procedure-sub-category',
                loadChildren: './mot-procedure-sub-category/mot-procedure-sub-category.module#MotProcedureSubCategoryModule'
            },
            {
                path: 'mot-procedure-type',
                loadChildren: './mot-procedure-type/mot-procedure-type.module#MotProcedureTypeModule'
            },
            {path: 'mot-surgery-note', loadChildren: './mot-surgery-note/mot-surgery-note.module#MotSurgeryNoteModule'},
            {path: 'mrad-film-size', loadChildren: './mrad-film-size/mrad-film-size.module#MradFilmSizeModule'},
            {path: 'mrad-modality', loadChildren: './mrad-modality/mrad-modality.module#MradModalityModule'},
            {path: 'mrad-template', loadChildren: './mrad-template/mrad-template.module#MradTemplateModule'},
            {
                path: 'mrad-template-result',
                loadChildren: './mrad-template-result/mrad-template-result.module#MradTemplateResultModule'
            },
            {path: 'mrad-test', loadChildren: './mrad-test/mrad-test.module#MradTestModule'},
            {
                path: 'mrad-test-category',
                loadChildren: './mrad-test-category/mrad-test-category.module#MradTestCategoryModule'
            },
            {path: 'address', loadChildren: './mst-address/mst-address.module#MstAddressModule'},
            {path: 'address-type', loadChildren: './mst-address-type/mst-address-type.module#MstAddressTypeModule'},
            {
                path: 'appointment-instruction',
                loadChildren: './mst-appointment-instruction/mst-appointment-instruction.module#MstAppointmentInstructionModule'
            },
            {
                path: 'appointment-reason',
                loadChildren: './mst-appointment-reason/mst-appointment-reason.module#MstAppointmentReasonModule'
            },
            {
                path: 'appointment-type',
                loadChildren: './mst-appointment-type/mst-appointment-type.module#MstAppointmentTypeModule'
            },
            {
                path: 'associated-company',
                loadChildren: './mst-associated-company/mst-associated-company.module#MstAssociatedCompanyModule'
            },
            {path: 'bank', loadChildren: './mst-bank/mst-bank.module#MstBankModule'},
            {path: 'bank-branch', loadChildren: './mst-bank-branch/mst-bank-branch.module#MstBankBranchModule'},
            {path: 'bloodgroup', loadChildren: './mst-bloodgroup/mst-bloodgroup.module#MstBloodgroupModule'},
            {path: 'booking-type', loadChildren: './mst-booking-type/mst-booking-type.module#MstBookingTypeModule'},
            {path: 'cabin', loadChildren: './mst-cabin/mst-cabin.module#MstCabinModule'},
            {path: 'cash-counter', loadChildren: './mst-cash-counter/mst-cash-counter.module#MstCashCounterModule'},
            {path: 'center-waiver', loadChildren: './mst-center-waiver/mst-center-waiver.module#MstCenterWaiverModule'},
            {path: 'city', loadChildren: './mst-city/mst-city.module#MstCityModule'},
            {path: 'landmark', loadChildren: './mst-landmark/mst-landmark.module#MstLandmarkModule'},
            {path: 'company', loadChildren: './mst-company/mst-company.module#MstCompanyModule'},
            {path: 'company-type', loadChildren: './mst-company-type/mst-company-type.module#MstCompanyTypeModule'},
            {
                path: 'sponsor-combination',
                loadChildren: './mst-sponsor-combination/mst-sponsor-combination.module#MstSponsorCombinationModule'
            },
            {path: 'mst-consent', loadChildren: './mst-consent/mst-consent.module#MstConsentModule'},
            // {path: 'mst-consent-type', loadChildren: './mst-consent-type/mst-consent-type.module#MstConsentTypeModule'},
            {path: 'country', loadChildren: './mst-country/mst-country.module#MstCountryModule'},
            {path: 'cpoe-template', loadChildren: './mst-cpoe-template/mst-cpoe-template.module#MstCpoeTemplateModule'},
            {
                path: 'mst-class',
                loadChildren: './mst-class/mst-class.module#MstClassModule'
            },
            {path: 'mpath-result', loadChildren: './mpath-result/mpath-result.module#MpathResultModule'},
            {path: 'day', loadChildren: './mst-day/mst-day.module#MstDayModule'},
            {path: 'department', loadChildren: './mst-department/mst-department.module#MstDepartmentModule'},
            {
                path: 'department-waiver',
                loadChildren: './mst-department-waiver/mst-department-waiver.module#MstDepartmentWaiverModule'
            },
            {path: 'mst-cluster', loadChildren: './mst-cluster/mst-cluster.module#MstClusterModule'},
            {path: 'gpdepartment', loadChildren: './mst-gp-department/mst-gp-department.module#MstGpDepartmentModule'},
            {path: 'designation', loadChildren: './mst-designation/mst-designation.module#MstDesignationModule'},
            {path: 'gpdesignation', loadChildren: './mst-gp-designation/mst-gp-designation.module#MstGpDesignationModule'},
            {path: 'doctor-waiver', loadChildren: './mst-doctor-waiver/mst-doctor-waiver.module#MstDoctorWaiverModule'},
            {path: 'email-template', loadChildren: './mst-email-template/mst-email-template.module#MstEmailTemplateModule'},
            {
                path: 'employment-status',
                loadChildren: './mst-employment-status/mst-employment-status.module#MstEmploymentStatusModule'
            },
            {path: 'encounter-type', loadChildren: './mst-encounter-type/mst-encounter-type.module#MstEncounterTypeModule'},
            {path: 'equipment', loadChildren: './mst-equipment/mst-equipment.module#MstEquipmentModule'},
            {path: 'ethnicity', loadChildren: './mst-ethnicity/mst-ethnicity.module#MstEthnicityModule'},
            {path: 'gender', loadChildren: './mst-gender/mst-gender.module#MstGenderModule'},
            {
                path: 'income-category',
                loadChildren: './mst-income-category/mst-income-category.module#MstIncomeCategoryModule'
            },
            {path: 'language', loadChildren: './mst-language/mst-language.module#MstLanguageModule'},
            {path: 'marital-status', loadChildren: './mst-marital-status/mst-marital-status.module#MstMaritalStatusModule'},
            {path: 'mis-type', loadChildren: './mst-mis-type/mst-mis-type.module#MstMisTypeModule'},
            {path: 'mlc-checklist', loadChildren: './mst-mlc-checklist/mst-mlc-checklist.module#MstMlcChecklistModule'},
            {
                path: 'mlc-juridiction',
                loadChildren: './mst-mlc-juridiction/mst-mlc-juridiction.module#MstMlcJuridictionModule'
            },
            {path: 'nationality', loadChildren: './mst-nationality/mst-nationality.module#MstNationalityModule'},
            {
                path: 'notification-config',
                loadChildren: './mst-notification-config/mst-notification-config.module#MstNotificationConfigModule'
            },
            {path: 'occupation', loadChildren: './mst-occupation/mst-occupation.module#MstOccupationModule'},
            {path: 'org', loadChildren: './mst-org/mst-org.module#MstOrgModule'},
            {path: 'patient', loadChildren: './mst-patient/mst-patient.module#MstPatientModule'},
            {path: 'patient-source', loadChildren: './mst-patient-source/mst-patient-source.module#MstPatientSourceModule'},
            {path: 'patient-type', loadChildren: './mst-patient-type/mst-patient-type.module#MstPatientTypeModule'},
            {path: 'payment-mode', loadChildren: './mst-payment-mode/mst-payment-mode.module#MstPaymentModeModule'},
            {path: 'priority', loadChildren: './mst-priority/mst-priority.module#MstPriorityModule'},
            {path: 'race', loadChildren: './mst-race/mst-race.module#MstRaceModule'},
            {
                path: 'referring-entity',
                loadChildren: './mst-referring-entity/mst-referring-entity.module#MstReferringEntityModule'
            },
            {
                path: 'referring-entity-type',
                loadChildren: './mst-referring-entity-type/mst-referring-entity-type.module#MstReferringEntityTypeModule'
            },
            {path: 'relation', loadChildren: './mst-relation/mst-relation.module#MstRelationModule'},
            {path: 'schedule', loadChildren: './mst-schedule/mst-schedule.module#MstScheduleModule'},
            {path: 'shift', loadChildren: './mst-shift/mst-shift.module#MstShiftModule'},
            {path: 'sms-template', loadChildren: './mst-sms-template/mst-sms-template.module#MstSmsTemplateModule'},
            {path: 'speciality', loadChildren: './mst-speciality/mst-speciality.module#MstSpecialityModule'},
            {path: 'mst-staff', loadChildren: './mst-staff/mst-staff.module#MstStaffModule'},
            {path: 'state', loadChildren: './mst-state/mst-state.module#MstStateModule'},
            {path: 'strength-unit', loadChildren: './mst-strength-unit/mst-strength-unit.module#MstStrengthUnitModule'},
            {path: 'sub-department', loadChildren: './mst-sub-department/mst-sub-department.module#MstSubDepartmentModule'},
            {
                path: 'super-speciality',
                loadChildren: './mst-super-speciality/mst-super-speciality.module#MstSuperSpecialityModule'
            },
            {path: 'title', loadChildren: './mst-title/mst-title.module#MstTitleModule'},
            {path: 'triage', loadChildren: './mst-triage/mst-triage.module#MstTriageModule'},
            {path: 'unit', loadChildren: './mst-unit/mst-unit.module#MstUnitModule'},
            {
                path: 'unit-measurment',
                loadChildren: './mst-unit-measurment/mst-unit-measurment.module#MstUnitMeasurmentModule'
            },
            {path: 'user', loadChildren: './mst-user/mst-user.module#MstUserModule'},
            {path: 'user-type', loadChildren: './mst-user-type/mst-user-type.module#MstUserTypeModule'},
            {path: 'visit', loadChildren: './mst-visit/mst-visit.module#MstVisitModule'},
            {
                path: 're-type',
                loadChildren: './mst-referring-entity-type/mst-referring-entity-type.module#MstReferringEntityTypeModule'
            },
            {path: 're-master', loadChildren: './mst-referring-entity/mst-referring-entity.module#MstReferringEntityModule'},
            //  {path: 'appointment', loadChildren: './trn-appointment/trn-appointment.module#TrnAppointmentModule'},
            {path: 'tbill-plan-item', loadChildren: './tbill-plan-item/tbill-plan-item.module#TbillPlanItemModule'},
            {
                path: 'tbill-plan-service',
                loadChildren: './tbill-plan-service/tbill-plan-service.module#TbillPlanServiceModule'
            },
            {
                path: 'tbill-plan-uncovered-drugs',
                loadChildren: './tbill-plan-uncovered-drug/tbill-plan-uncovered-drug.module#TbillPlanUncoveredDrugModule'
            },
            {
                path: 'tbill-plan-uncovered-service',
                loadChildren: './tbill-plan-uncovered-service/tbill-plan-uncovered-service.module#TbillPlanUncoveredServiceModule'
            },
            {
                path: 'trn-doctor-schedule-detail',
                loadChildren: './trn-doctor-schedule-detail/trn-doctor-schedule-detail.module#TrnDoctorScheduleDetailModule'
            },
            {
                path: 'trn-doctor-schedule-detail/:deptId/:subDeptId/:staffid',
                loadChildren: './trn-doctor-schedule-detail/trn-doctor-schedule-detail.module#TrnDoctorScheduleDetailModule'
            },
            /*{
                path: 'mst-shift-schedule',
                loadChildren: './mst-shift-schedule/mst-shift-schedule.module#MstShiftScheduleModule'
            },*/
            {
                path: 'mst-schedule-detail',
                loadChildren: './mst-schedule-detail/mst-schedule-detail.module#MstScheduleDetailModule'
            },
            {path: 'visit-type', loadChildren: './mst-visit-type/mst-visit-type.module#MstVisitTypeModule'},
            {
                path: 'trn-sponcer-combination/:user_id/:visit_id/:source/:patient_id',
                loadChildren: './trn-sponsor-combination/trn-sponsor-combination.module#TrnSponsorCombinationModule'
            },
            {
                path: 'trn-sponcer-combination/:user_id/:visit_id/:source/:patient_id',
                loadChildren: './trn-sponsor-combination/trn-sponsor-combination.module#TrnSponsorCombinationModule'
            },
            {
                path: 'trn-sponcer-combination/:user_id/:visit_id/:source/:patient_id/:type',
                loadChildren: './trn-sponsor-combination/trn-sponsor-combination.module#TrnSponsorCombinationModule'
            },
            // {
            //   path: 'trn-sponcer-combination/:user_id/:visit_id/:sponcertype/:patientId',
            //   loadChildren: './trn-sponsor-combination/trn-sponsor-combination.module#TrnSponsorCombinationModule'
            // },
            {path: 'allergy', loadChildren: './memr-allergy/memr-allergy.module#MemrAllergyModule'},
            {
                path: 'allergy-sensitivity',
                loadChildren: './memr-allergy-sensitivity/memr-allergy-sensitivity.module#MemrAllergySensitivityModule'
            },
            {
                path: 'chief-complaint',
                loadChildren: './memr-chief-complaint/memr-chief-complaint.module#MemrChiefComplaintModule'
            },
            {
                path: 'associate-chief-complaint',
                loadChildren: './memr-associate-chief-complaint/memr-associate-chief-complaint.module#MemrAssociateChiefComplaintModule'
            },
            {
                path: 'disease-category',
                loadChildren: './memr-disease-category/memr-disease-category.module#MemrDiseaseCategoryModule'
            },
            {
                path: 'disease-sub-category',
                loadChildren: './memr-disease-sub-category/memr-disease-sub-category.module#MemrDiseaseSubCategoryModule'
            },
            {path: 'disease-type', loadChildren: './memr-disease-type/memr-disease-type.module#MemrDiseaseTypeModule'},

            {path: 'memr-doctors-note', loadChildren: './memr-doctors-note/memr-doctors-note.module#MemrDoctorsNoteModule'},

            {path: 'drug-duration', loadChildren: './memr-drug-duration/memr-drug-duration.module#MemrDrugDurationModule'},
            {
                path: 'drug-instruction',
                loadChildren: './memr-drug-instruction/memr-drug-instruction.module#MemrDrugInstructionModule'
            },
            {
                path: 'history-template',
                loadChildren: './memr-history-template/memr-history-template.module#MemrHistoryTemplateModule'
            },
            {path: 'icd-code', loadChildren: './memr-icd-code/memr-icd-code.module#MemrIcdCodeModule'},
            {path: 'symptom', loadChildren: './memr-symptom/memr-symptom.module#MemrSymptomModule'},
            {
                path: 'document-category',
                loadChildren: './mst-document-category/mst-document-category.module#MstDocumentCategoryModule'
            },
            {
                path: 'dose-dispensing-type',
                loadChildren: './mst-dose-dispensing-type/mst-dose-dispensing-type.module#MstDoseDispensingTypeModule'
            },
            {path: 'dose-frequency', loadChildren: './mst-dose-frequency/mst-dose-frequency.module#MstDoseFrequencyModule'},
            {path: 'drug', loadChildren: './mst-drug/mst-drug.module#MstDrugModule'},
            {path: 'molecule', loadChildren: './mst-molecule/mst-molecule.module#MstMoleculeModule'},
            {
                path: 'non-drug-allergy',
                loadChildren: './mst-non-drug-allergy/mst-non-drug-allergy.module#MstNonDrugAllergyModule'
            },
            {path: 'route', loadChildren: './mst-route/mst-route.module#MstRouteModule'},
            {path: 'strength-unit', loadChildren: './mst-strength-unit/mst-strength-unit.module#MstStrengthUnitModule'},
            {
                path: 'doctors-advice',
                loadChildren: './temr-doctors-advice/temr-doctors-advice.module#TemrDoctorsAdviceModule'
            },
            {path: 'doctors-order', loadChildren: './temr-doctors-order/temr-doctors-order.module#TemrDoctorsOrderModule'},
            {
                path: 'document-upload',
                loadChildren: './temr-document-upload/temr-document-upload.module#TemrDocumentUploadModule'
            },
            {path: 'timeline', loadChildren: './temr-timeline/temr-timeline.module#TemrTimelineModule'},
            {path: 'visit-allergy', loadChildren: './temr-visit-allergy/temr-visit-allergy.module#TemrVisitAllergyModule'},

            {path: 'visit-doctors-note', loadChildren: './temr-visit-doctors-note/temr-visit-doctors-note.module#TemrVisitDoctorsNoteModule'},
            {
                path: 'visit-chief-complaint',
                loadChildren: './temr-visit-chief-complaint/temr-visit-chief-complaint.module#TemrVisitChiefComplaintModule'
            },
            {
                path: 'visit-diagnosis',
                loadChildren: './temr-visit-diagnosis/temr-visit-diagnosis.module#TemrVisitDiagnosisModule'
            },
            {path: 'visit-history', loadChildren: './temr-visit-history/temr-visit-history.module#TemrVisitHistoryModule'},
            {
                path: 'visit-non-drug-allergy',
                loadChildren: './temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.module#TemrVisitNonDrugAllergyModule'
            },
            {path: 'visit-symptom', loadChildren: './temr-visit-symptom/temr-visit-symptom.module#TemrVisitSymptomModule'},
            {path: 'vital', loadChildren: './temr-vital/temr-vital.module#TemrVitalModule'},
            {path: 'drug-molecule', loadChildren: './trn-drug-molecule/trn-drug-molecule.module#TrnDrugMoleculeModule'},
            {path: 'mpath-agency', loadChildren: './mpath-agency/mpath-agency.module#MpathAgencyModule'},
            {path: 'mpath-container', loadChildren: './mpath-container/mpath-container.module#MpathContainerModule'},
            {path: 'mpath-machine', loadChildren: './mpath-machine/mpath-machine.module#MpathMachineModule'},
            {
                path: 'mpath-parameter',
                loadChildren: './mpath-parameter/mpath-parameter.module#MpathParameterModule'
            },
            {
                path: 'mpath-parameter-method',
                loadChildren: './mpath-parameter-method/mpath-parameter-method.module#MpathParameterMethodModule'
            },
            {
                path: 'mpath-parameter/:parameterId',
                loadChildren: './mpath-parameter/mpath-parameter.module#MpathParameterModule'
            },
            {
                path: 'mpath-parameter-text',
                loadChildren: './mpath-parameter-text/mpath-parameter-text.module#MpathParameterTextModule'
            },
            {
                path: 'mpath-parameter/:parameterId',
                loadChildren: './mpath-parameter/mpath-parameter.module#MpathParameterModule'
            },
            {
                path: 'mpath-parameter-unit',
                loadChildren: './mpath-parameter-unit/mpath-parameter-unit.module#MpathParameterUnitModule'
            },
            {path: 'mpath-sample', loadChildren: './mpath-sample/mpath-sample.module#MpathSampleModule'},
            {
                path: 'mpath-sample-suitability',
                loadChildren: './mpath-sample-suitability/mpath-sample-suitability.module#MpathSampleSuitabilityModule'
            },
            {path: 'mpath-test', loadChildren: './mpath-test/mpath-test.module#MpathTestModule'},
            {path: 'mpath-test/:testId', loadChildren: './mpath-test/mpath-test.module#MpathTestModule'},
            {
                path: 'rpath-test-parameter',
                loadChildren: './mpath-test/rpath-test-parameter/rpath-test-parameter.module#RpathTestParameterModule'
            },
            {path: 'mpath-result', loadChildren: './mpath-result/mpath-result.module#MpathResultModule'},
            {
                path: 'mpath-sample-rejection',
                loadChildren: './mpath-sample-rejection/mpath-sample-rejection.module#MpathSampleRejectionModule'
            },
            {path: 'mpath-test-template', loadChildren: './mpath-test-template/mpath-test-template.module#MpathTestTemplateModule'},
            {path: 'district', loadChildren: './mst-district/mst-district.module#MstDistrictModule'},
            {path: 'taluka', loadChildren: './mst-taluka/mst-taluka.module#MstTalukaModule'},
            {path: 'landmark', loadChildren: './mst-landmark/mst-landmark.module#MstLandmarkModule'},
            {path: 'item-group', loadChildren: './inv-item-group/inv-item-group.module#InvItemGroupModule'},
            {path: 'item-company', loadChildren: './inv-item-company/inv-item-company.module#InvItemCompanyModule'},
            {path: 'item-category', loadChildren: './inv-item-category/inv-item-category.module#InvItemCategoryModule'},
            {
                path: 'item-dispensing-type',
                loadChildren: './inv-item-dispensing-type/inv-item-dispensing-type.module#InvItemDispensingTypeModule'
            },
            // {path: 'item-group', loadChildren: './inv-item-group/inv-item-group.module#InvItemGroupModule'},
            {path: 'item-kit-package', loadChildren: './inv-item-kit-package/inv-item-kit-package.module#InvItemKitPackageModule'},

            {path: 'service-wise-item-consumption', loadChildren: './inv-service-wise-item-consumption/inv-service-wise-item-consumption.module#InvServiceWiseItemConsumptionModule'},
            {
                path: 'item-storage-type',
                loadChildren: './inv-item-storage-type/inv-item-storage-type.module#InvItemStorageTypeModule'
            },
            {
                path: 'item-terms-and-condition',
                loadChildren: './inv-item-terms-and-condition/inv-item-terms-and-condition.module#InvItemTermsAndConditionModule'
            },
            {path: 'mode-scrapsale', loadChildren: './inv-mode-scrapsale/inv-mode-scrapsale.module#InvModeScrapsaleModule'},
            {
                path: 'pregnancy-class',
                loadChildren: './inv-pregnancy-class/inv-pregnancy-class.module#InvPregnancyClassModule'
            },
            {path: 'store', loadChildren: './inv-store/inv-store.module#InvStoreModule'},
            {path: 'supplier', loadChildren: './inv-supplier/inv-supplier.module#InvSupplierModule'},
            {path: 'primary-tax', loadChildren: './inv-primary-tax/inv-primary-tax.module#InvPrimaryTaxModule'},
            {path: 'tax', loadChildren: './inv-tax/inv-tax.module#InvTaxModule'},
            {
                path: 'therapeutic-class',
                loadChildren: './inv-therapeutic-class/inv-therapeutic-class.module#InvTherapeuticClassModule'
            },
            {
                path: 'unit-of-measurment',
                loadChildren: './inv-unit-of-measurment/inv-unit-of-measurment.module#InvUnitOfMeasurmentModule'
            },
            {path: 'item', loadChildren: './inv-item/inv-item.module#InvItemModule'},
            {path: 'item/:add', loadChildren: './inv-item/inv-item.module#InvItemModule'},
            {path: 'inv-item-sub-category', loadChildren: './inv-item-sub-category/inv-item-sub-category.module#InvItemSubCategoryModule'},
            {path: 'inv-item-subgroup', loadChildren: './inv-item-subgroup/inv-item-subgroup.module#InvItemSubgroupModule'},
            {path: 'inv-item-type', loadChildren: './inv-item-type/inv-item-type.module#InvItemTypeModule'},
            {path: 'inv-item-subtype', loadChildren: './inv-item-subtype/inv-item-subtype.module#InvItemSubTypeModule'},
            {path: 'currency', loadChildren: './mac-currency/mac-currency.module#MacCurrencyModule'},
            {path: 'inv-generic-name', loadChildren: './inv-generic-name/inv-generic-name.module#InvGenericNameModule'},
            {path: 'indent-flag', loadChildren: './inv-indent-flag/inv-indent-flag.module#InvIndentFlagModule'},
            {
                path: 'mipd-admission-purpose',
                loadChildren: './mipd-admission-purpose/mipd-admission-purpose.module#MipdAdmissionPurposeModule'
            },
            {path: 'role', loadChildren: './mst-role/mst-role.module#MstRoleModule'},
            {path: 'action', loadChildren: './mst-action/mst-action.module#MstActionModule'},
            {path: 'mst-timeunit', loadChildren: './mst-timeunit/mst-timeunit.module#MstTimeunitModule'},
            {path: 'diet-item', loadChildren: './mst-diet-item/mst-diet-item.module#MstDietItemModule'},
            {
                path: 'diet-patient-category',
                loadChildren: './mst-diet-patient-category/mst-diet-patient-category.module#MstDietPatientCategoryModule'
            },
            {path: 'diet-schedule', loadChildren: './mst-diet-schedule/mst-diet-schedule.module#MstDietScheduleModule'},
            {path: 'diet-unit', loadChildren: './mst-diet-unit/mst-diet-unit.module#MstDietUnitModule'},
            {
                path: 'vacc-patient-category',
                loadChildren: './mst-vacc-patient-category/mst-vacc-patient-category.module#MstVaccPatientCategoryModule'
            },
            {
                path: 'vaccination-standard-chart',
                loadChildren: './mst-vacc-auto-chart/mst-vacc-auto-chart.module#MstVaccAutoChartModule'
            },
            {path: 'clinical-form', loadChildren: './memr-clinical-form/memr-clinical-form.module#MemrClinicalFormModule'},
            {path: 'vacc-site', loadChildren: './mst-vacc-site/mst-vacc-site.module#MstVaccSiteModule'},
            {path: 'mst-module', loadChildren: './mst-module/mst-module.module#MstModuleModule'},
            {
                path: 'application-configuration',
                loadChildren: './application-configuration/application-configuration.module#ApplicationConfigurationModule'
            },
            {
                path: 'mbill-doctore-share',
                loadChildren: './mbill-doctore-share/mbill-doctore-share.module#MbillDoctoreShareModule'
            },
            {
                path: 'about-us', component: AboutUsComponent
            },
            {path: 'ambulance', loadChildren: './mst-ambulance/mst-ambulance.module#MstAmbulanceModule'},
            {
                path: 'ambulancerequisition',
                loadChildren: './mst-ambulancerequisition/mst-ambulancerequisition.module#MstAmbulancerequisitionModule'
            },
            {
                path: 'incidentmanagement',
                loadChildren: './mst-incidentmanagement/mst-incidentmanagement.module#MstAmbulancerequisitionModule'
            },
            {
                path: 'expensemanagement',
                loadChildren: './mst-expensemanagement/mst-expensemanagement.module#MstExpensemanagementModule'
            },
            {
                path: 'infectionsystem',
                loadChildren: './mst-infectionsystem/mst-infectionsystem.module#MstInfectionsystemModule'
            },
            {
                path: 'mci',
                loadChildren: './mst-mci/mst-mci.module#MstMciModule'
            },
            {path: 'mst-auto-charges', loadChildren: './mst-auto-charges/mst-auto-charges.module#MstAutoChargesModule'},
            {path: 'tbill-agency-rate', loadChildren: './tbill-agency-rate/tbill-agency-rate.module#TbillAgencyRateModule'},
            {
                path: 'mbill-doctore-share',
                loadChildren: './mbill-doctore-share/mbill-doctore-share.module#MbillDoctoreShareModule'
            },
            // Nst Configuration Start
            {
                path: 'method-delivery',
                loadChildren: './nst-method-delivery/nst-method-delivery.module#NstMethodDeliveryModule'
            },
            {
                path: 'nst-definition',
                loadChildren: './nst-nursing-station-defination/nst-nursing-station-defination.module#NstNursingStationDefinationModule'
            },
            {
                path: 'actionmodulemst',
                loadChildren: './action-module-mst/action-module-mst.module#ActionModuleMstModule'
            },
            {
                path: 'actionsubmodulemst',
                loadChildren: './action-submodule-mst/action-submodule-mst.module#ActionSubModuleMstModule'
            },
            {
                path: 'actionrolemst',
                loadChildren: './action-role-mst/action-role-mst.module#ActionRoleMstModule'
            },
            {
                path: 'actionuserrolemst',
                loadChildren: './action-user-role-mst/action-user-role-mst.module#ActionUserRoleMstModule'
            },
            {
                path: 'actionsubmodulebuttonmst',
                loadChildren: './action-submodule-button-mst/action-submodule-button-mst.module#ActionSubmoduleButtonMstModule'
            },
            {
                path: 'mstsocialstatus',
                loadChildren: './mst-social-status/mst-social-status.module#MstSocialStatusModule'
            },
            {
                path: 'policestationmst',
                loadChildren: './mst-police-station/mst-police-station.module#MstPoliceStationModule'
            },
            {path: 'inv-compound-name', loadChildren: './inv-compound-name/inv-compound-name.module#InvCompoundNameModule'},
            {path: 'blood-bank', loadChildren: './trn-blood-bank/trn-blood-bank.module#TrnBloodBankModule'},
            {path: 'blood-stock', loadChildren: './trn-blood-stock/trn-blood-stock.module#TrnBloodStockModule'},
            {path: 'issue-management', loadChildren: './trn-issue-management/trn-issue-management.module#TrnIssueManagementModule'},
            {path: 'anaesthesia-note', loadChildren: './mst-anaesthesia-note/mst-anaesthesia-note.module#MstAnaesthesiaNoteModule'},
            {path: 'anaesthesia-type', loadChildren: './mst-anaesthesia-type/mst-anaesthesia-type.module#MstAnaesthesiaTypeModule'},
            {path: 'intra-operative-instructions', loadChildren: './mst-intra-operative-instructions/mst-intra-operative-instructions.module#MstIntraOperativeInstructionsModule'},
            {path: 'operation-result', loadChildren: './mst-operation-result/mst-operation-result.module#MstOperationResultModule'},
            {path: 'operation-status', loadChildren: './mst-operation-status/mst-operation-status.module#MstOperationStatusModule'},
            {path: 'operation-theatre', loadChildren: './mst-operation-theatre/mst-operation-theatre.module#MstOperationTheatreModule'},
            {path: 'operation-theatre-table', loadChildren: './mst-operation-theatre-table/mst-operation-theatre-table.module#MstOperationTheatreTableModule'},
            {path: 'post-operative-instructions', loadChildren: './mst-post-operative-instructions/mst-post-operative-instructions.module#MstPostOperativeInstructionsModule'},
            {path: 'pre-operative-instructions', loadChildren: './mst-pre-operative-instructions/mst-pre-operative-instructions.module#MstPreOperativeInstructionsModule'},
            {path: 'procedure-category', loadChildren: './mst-procedure-category/mst-procedure-category.module#MstProcedureCategoryModule'},
            {path: 'procedure-checklist', loadChildren: './mst-procedure-checklist/mst-procedure-checklist.module#MstProcedureChecklistModule'},
            {path: 'procedure-subcategory', loadChildren: './mst-procedure-subcategory/mst-procedure-subcategory.module#MstProcedureSubcategoryModule'},
            {path: 'procedure-type', loadChildren: './mst-procedure-type/mst-procedure-type.module#MstProcedureTypeModule'},
            {path: 'procedure', loadChildren: './mst-procedure/mst-procedure.module#MstProcedureModule'},
            {
                path: 'trn-sponcer-combination/:user_id/:visit_id/:sponcertype',
                loadChildren: './trn-sponsor-combination/trn-sponsor-combination.module#TrnSponsorCombinationModule'
            },
            {path: 'issuereg', loadChildren: './trn-issue-management/trn-issue-management.module#TrnIssueManagementModule'},
            {
                path: 'mstemrtemplate',
                loadChildren: './mst-emr-template/mst-emr-template.module#MstEmrTemplateModule'
            },
            {path: 'mst-citizen-id-proof', loadChildren: './mst-citizen-id-proof/mst-citizen-id-proof.module#MstCitizenIdProofModule'},
            {path: 'memr-auto-daily-close-visit', loadChildren: './memr-auto-daily-close-visit/memr-auto-daily-close-visit.module#MemrAutoDailyCloseVisitModule'},
            {path: 'mst-field', loadChildren: './mst-field/mst-field.module#MstFieldModule'},
            {path: 'mst-section', loadChildren: './mst-section/mst-section.module#MstSectionModule'},
            {path: 'mst-tab', loadChildren: './mst-tab/mst-tab.module#MstTabModule'},
            {path: 'mst-set', loadChildren: './mst-set/mst-set.module#MstSetModule'},
            {path: 'mst-discharge-summary-form', loadChildren: './mst-discharge-summary-form/mst-discharge-summary-form.module#MstDischargeSummaryFormModule'},
            {path: 'mst-mode-of-transfer', loadChildren: './mst-mode-of-transfer/mst-mode-of-transfer.module#MstModeOfTransferModule'},
            {path: 'mst-followup-config', loadChildren: './mst-followup-config/mst-followup-config.module#MstFollowupConfigModule'},
            {path: 'mst-gp-set', loadChildren: './mst-gp-set/mst-gp-set.module#MstGpSetModule'},
            {path: 'mrad-test-template', loadChildren: './mrad-test-template/mrad-test-template.module#MradTestTemplateModule'},
            {path: 'import-data', loadChildren: './import-data/import-data.module#ImportDataModule'},
            {path: 'user-data', loadChildren: './user-data-module/user-data.module#UserDataModel'},
        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/configuration.routing.ts